import { ref, computed } from "vue";
import { defineStore } from "pinia";
import ApiService from "@/core/services/ApiService";
import { SystemInitDto, UserWithSimpleInfoDto } from "../core/services/ApiClient";
import { buildZoneTree } from "~/core/helpers/zoneTree";
import type { ZoneTreeDto } from "~/core/types/zone";
import { setSystemObjectId } from "~/core/services/OrganizationService";

export const useSystemStore = defineStore("system", () => {
    const systemData = ref<SystemInitDto>();
    const users = ref<UserWithSimpleInfoDto[]>([]);
    const newsCount = ref<null>();
    const isInited = ref(false);

    const zones = computed<ZoneTreeDto[]>(() =>
        buildZoneTree(systemData.value?.category)
    );

    async function init() {
        const response = await ApiService.apiClient.initSystem()
        if (response.data) {
            isInited.value = true
            systemData.value = response.data;
            setSystemObjectId(response.data.systemObjectId);
            users.value = response.data.users || [];
        }
    }

    /** Tổ chức hiện tại là đơn vị hệ thống (init.isSystem). SuperAdmin vẫn lấy từ init.isSuperAdmin. */
    const isSystem = computed(() => !!systemData.value?.isSystem);
    const isSuperAdmin = computed(() => !!systemData.value?.isSuperAdmin);
    /** SuperAdmin không sửa được trong ứng dụng; tài khoản quản trị hệ thống chỉ SuperAdmin thao tác (API cũng chặn). */
    const canManageAccount = (item: { isSystemAdmin?: boolean; isSuperAdmin?: boolean }) =>
        !item.isSuperAdmin && (!item.isSystemAdmin || isSuperAdmin.value);

    function reset() {
        isInited.value = false;
        systemData.value = undefined;
        users.value = [];
    }

    function newsGetCount() {
        ApiService.apiClient.newsGetCount().then((response) => {
            if (response.data) {
                newsCount.value = response.data;
            }
        });
    }

    return {
        isInited,
        isSystem,
        isSuperAdmin,
        canManageAccount,
        systemData,
        users,
        zones,
        init,
        reset,
        newsCount,
        newsGetCount
    };
});
